<template>
  <div
    class="containerFull_basketballLeagueCommon"
    id="containerFull_body"
    v-if="currThemeObj"
  >
    <div class="fix_header">
      <platfrom_menu
        :currThemeObj="currThemeObj"
        :selectData="platfromMenu_selectData"
        :userInfor="platfromMenu_userInfor"
        :groupList="platfromMenu_groupList"
        :currGroup="platfromMenu_currGroup"
        :currCid="currCid"
        :currSid="currSid"
        :curPageInitNum="containerFull_curPageInitNum"
        @changeSidToInitPageEvent="changeSidToInitPage"
        @changeSidEvent="platfrom_changeSid"
        @changeGroupEvent="platfromMenu_changeGroup"
      ></platfrom_menu>
    </div>
    <div class="mix_body">
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currGroup="platfromMenu_currGroup"
        :groupChangeInitPage="containThemeRouteName"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :curPageInitNum="containerFull_curPageInitNum"
        :themeHeaderBannerImage="'detail_banner'"
      ></router-view>
      <!-- <keep-alive :include="keepAlive">
          </keep-alive> -->
    </div>
    <div class="mix_footer">
      <component :is="footerCustomDom" :currThemeObj="currThemeObj" />
    </div>

    <publicThemeDialog
      v-if="isShowPublicThemeDialog"
      :currThemeObj="currThemeObj"
      :isDialogFlag="isShowPublicThemeDialog"
      :dialogObj="publicThemeDialogObj"
      :axiosBaseUrl="axiosBaseUrl"
      :currGroup="platfromMenu_currGroup"
      :currCid="currCid"
      :currSid="currSid"
      @publicThemeDialogEvent="publicThemeDialogHandler"
      :commitBeforeCheckoutCallback="null"
      @actStyleItemEvent="actStyleItemEventHandler"
    ></publicThemeDialog>
  </div>
</template>

<script>
// 篮球 联赛  公共容器
import basketballLeagueCommon_data_mixin from '@mixins/basketball/leagueCommon_data_mixin'

export default {
  name: 'basketballLeague_common',
  props: {
    containerFullClassName: {
      type: String,
      default: '',
    },
    defaultPath: {
      type: Array,
      default: () => {
        return []
      },
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  mixins: [basketballLeagueCommon_data_mixin],
}

// // 篮球联赛容器
// import platfrom_menu from '@components/base/menu'
// import publicThemeDialog from '@components/base/theme/publicThemeDialog.vue'
// import containerFull_common_data_mixin from '@mixins/containerFull_common_data'
// import platfrom_createThemeItem_data_mixin from '@mixins/platfrom_createThemeItem_data'
// import { https_basketball_seasonList } from '@api/platfrom_basketball_api'

// import { https_manage_getGroupData } from '@api/platfrom_base_api'

// export default {
//   name: 'containerFull_basketballLeagueCommon',
//   mixins: [
//     containerFull_common_data_mixin,
//     platfrom_createThemeItem_data_mixin,
//   ],
//   components: {
//     platfrom_menu,
//     publicThemeDialog,
//   },
//   data() {
//     return {
//       onlyOneSeasonFlag: true, //该赛事不需要切换赛季，默认取后端第一个赛季数据
//       currCid: null, //109
//       currSid: null,
//       currSeasonName: null,
//       dynamicConfig: null,
//       defaultPath: ['basketball', 'CBA', 'schedule'],
//       axiosBaseUrl: '/bkbleague',
//       platfromMenu_selectData: [],
//       platfromMenu_userInfor: {
//         companyName: '',
//         email: '',
//         identy: '',
//         role: '',
//         station: null,
//         stationName: '',
//         userAlias: '',
//         userId: '',
//       },
//       platfromMenu_groupList: [],
//       platfromMenu_currGroup: null,
//       containThemeRouteName: [
//         // 当组id变化时，这些页面重新加载数据
//       ],
//       containerFull_curPageInitNum: 0,
//       isShowPublicThemeDialog: false,
//       publicThemeDialogObj: null,
//     }
//   },
//   watch: {
//     $route(to, from) {
//       // 如果是从b到a页面，则不缓存b
//       // 注意 路由那么要与组件name一致
//       console.debug(from.name, to.name)
//     },
//   },
//   created() {
//     this.init()
//   },
//   methods: {
//     platfrom_changeSid(sid) {
//       this.currSid = sid
//     },
//     changeSidToInitPage(num) {
//       this.containerFull_curPageInitNum = num
//     },
//     platfromMenu_changeGroup(item) {
//       this.platfromMenu_groupList.forEach((val) => {
//         if (item.groupId == val.groupId) {
//           val.act = true
//         } else {
//           val.act = false
//         }
//       })
//       this.platfromMenu_currGroup = item
//       window.mixtmt_platfrom.currGroup = item
//     },
//     async init() {
//       const userInfor = JSON.parse(
//         this.$localStorage.getItem('mixtmt_userInfo')
//       )
//       if (userInfor) {
//         this.platfromMenu_userInfor = userInfor
//       }

//       if (!window.mixtmt_platfrom.currGroup) {
//         // 防止在世界杯中刷新页面，没有组数据
//         await this.getGroupData()
//       } else {
//         this.platfromMenu_currGroup = window.mixtmt_platfrom.currGroup
//       }

//       const groupList = JSON.parse(
//         this.$localStorage.getItem('mixtmt_groupList')
//       )
//       if (groupList) {
//         // 防止在home页切换组别，世界杯没有同步
//         this.platfromMenu_groupList = groupList
//         this.platfromMenu_groupList.forEach((val) => {
//           if (this.platfromMenu_currGroup.groupId == val.groupId) {
//             val.act = true
//           } else {
//             val.act = false
//           }
//         })
//       }

//       // 获取赛季列表
//       await this.getSeasonList({ cid: this.currCid })
//     },
//     async getSeasonList(query) {
//       await https_basketball_seasonList(this.axiosBaseUrl, this.$axios, query)
//         .then((response) => {
//           const res = response.data
//           if (res.status === 0) {
//             if (this.onlyOneSeasonFlag) {
//               // 该赛事不需要切换赛季，永远默认展示当前赛季数据和皮肤，因此 container 初始化拿到赛季列表后，将第一个赛季 id 赋值给 currSid，并存到缓存中
//               this.currSid =
//                 res.data && res.data.length > 0 ? res.data[0].seasonId : ''
//               if (this.currSid) {
//                 const fullPath = this.$route.fullPath
//                 console.debug('this.$route:', this.$route, fullPath)
//                 let currCidKey = null
//                 if (fullPath && fullPath.indexOf('/') > -1) {
//                   currCidKey = fullPath.split('/')[1]
//                   let currSeasonMap = JSON.parse(
//                     this.$localStorage.getItem(
//                       'mixtmt_platfromV4_currSeasonMap'
//                     )
//                   )
//                   currSeasonMap[currCidKey].sid = this.currSid
//                   this.$localStorage.setItem(
//                     'mixtmt_platfromV4_currSeasonMap',
//                     JSON.stringify(currSeasonMap)
//                   )
//                 }
//               }
//             }
//             this.platfromMenu_selectData = res.data
//               ? res.data.map((val, index) => ({
//                   cid: query.cid,
//                   name: val.seasonName,
//                   key: val.seasonId,
//                   logoImage: val.seasonLogo,
//                   act: this.currSid
//                     ? this.currSid == val.seasonId
//                       ? true
//                       : false
//                     : index == 0
//                     ? true
//                     : false,
//                 }))
//               : []
//             // this.currSid = 1072020
//           } else {
//             if (res.message) {
//               // message：null，因此不弹出警示框（一般404 || 500的时候）；
//               // message不为null的时候展示警示框；
//               this.$message({
//                 showClose: true,
//                 message: res.message ? res.message : '服务器异常，请稍后再试',
//                 type: 'warning',
//               })
//             }
//           }
//         })
//         .catch((err) => {
//           console.debug(err)
//         })
//     },
//     async getGroupData() {
//       await https_manage_getGroupData('/api', this.$axios)
//         .then((response) => {
//           const res = response.data
//           console.debug('正常')
//           if (res.status === 0) {
//             // 测试切换组
//             // res.data = res.data.concat({
//             //   groupId: '06476a49-3db4-4b4c-91b3-b228714d6000',
//             //   groupName: '测试切换',
//             // })

//             this.platfromMenu_groupList = res.data
//               ? res.data.map((item, index) => {
//                   if (index == 0) {
//                     item.act = true
//                     this.platfromMenu_currGroup = item
//                     window.mixtmt_platfrom.currGroup = item
//                   } else {
//                     item.act = false
//                   }
//                   return item
//                 })
//               : []
//             this.$localStorage.setItem(
//               'mixtmt_groupList',
//               JSON.stringify(res.data)
//             )
//           } else {
//             if (res.message) {
//               // message：null，因此不弹出警示框（一般404 || 500的时候）；
//               // message不为null的时候展示警示框；
//               this.$message({
//                 showClose: true,
//                 message: res.message ? res.message : '服务器异常，请稍后再试',
//                 type: 'warning',
//               })
//             }
//           }
//         })
//         .catch((err) => {
//           console.debug(err)
//         })
//     },
//   },
// }
</script>

<style lang="scss">
.containerFull_basketballLeagueCommon {
  position: relative;
  width: 100%;
  /* height: auto; */
  font-size: 0.972vw;
  max-height: 100vh;
  overflow: auto;
  & .fix_header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1500;
    width: 100%;
    height: 8vw;
    background-color: var(--mixtmt_whiteColor);
  }
  & .mix_body {
    min-height: calc(100vh - 8vw - 9.722vw);
    padding: 0 9.722vw;
  }
  & .mix_footer {
    /* position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1000; */
    width: 100%;
  }

  .common_elPage {
    padding: 1.388vw 0;
    text-align: right;
    .el-pager li {
      padding: 0 0.53333vw;
      background: var(--mixtmt_whiteColor);
      font-size: 0.972vw;
      min-width: 2.22vw;
      height: 2.22vw;
      line-height: 2.22vw;
      box-sizing: border-box;
    }
    .el-pagination button,
    .el-pagination span:not([class*='suffix']) {
      display: inline-block;
      font-size: 0.972vw;
      min-width: 2.22vw;
      height: 2.22vw;
      line-height: 2.22vw;
      vertical-align: top;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .el-pagination .el-select .el-input {
      width: 6.944vw;
      margin: 0 0.66667vw;
    }
    .el-pagination .el-select .el-input .el-input__inner {
      padding-right: 1.11vw;
      border-radius: 0.4vw;
      height: 2.22vw;
      line-height: 2.22vw;
      font-size: 0.972vw;
    }
    .el-pagination__editor.el-input .el-input__inner {
      height: 2.22vw;
      font-size: 0.972vw;
      line-height: 2.22vw;
    }
    .el-pagination__editor.el-input {
      width: 4.16vw;
    }
    .el-pagination__jump {
      margin-left: 0.972vw;
    }
    .el-pagination__sizes {
      margin: 0;
    }
    .el-pager li.active,
    .el-pager li:hover,
    .el-pagination button:hover,
    .el-pagination__sizes .el-input .el-input__inner:hover {
      color: var(--mixtmt_subColor1_1);
    }
    .el-pagination__sizes .el-input .el-input__inner:hover,
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: var(--mixtmt_subColor1_1);
    }
  }
}

.mixtmt_pc {
  .containerFull_basketballLeagueCommon {
    /* padding: 8vw 9.722vw 9.722vw; */
    padding: 8vw 0 0 0;
  }
}
.mixtmt_ipad {
  .containerFull_basketballLeagueCommon {
    /* padding: 8vw 3vw 9.722vw; */
    padding: 8vw 0 0 0;
  }
}
</style>
